var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"wgu-layerlist",attrs:{"moduleName":"wgu-layerlist","icon":_vm.icon}},'wgu-module-card',_vm.$attrs,false),[_c('wgu-layerlist')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2be9e0fc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layerlist/LayerListWin.vue
// module id = fDqz
// module chunks = 1